import MiddlePanel from 'Components/MiddlePanel/MiddlePanel'
import Panel from 'Components/Panel/Panel'
import { useState } from 'react'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios'
import './DeleteMonthPanel.css'
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp'

const DeleteMonthPanel = ({
    showDeleteMonthPanel,
    onUpdateShowDeleteMonthPanel,
    onUpdatePanelCostSpreadsheet,
    onUpdateLoadingItemsMonth
}) => {
    const [dtStart, setDtStart] = useState(null);
    const [dtFinish, setDtFinish] = useState(null);

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        paddingLeft: '30px'
    }

    function onUpdateDtStart(date) {
        setDtStart(date)
        if (!dtFinish) {
            setDtFinish(new Date(date.getFullYear(), 11, date.getDate()))
        }
    }

    function cancelFunction() {
        onUpdateShowDeleteMonthPanel(false);
        resetVariables();
    }

    function resetVariables() {
        setDtStart(null);
        setDtFinish(null);
    }

    async function postFunction() {
        try {
            onUpdateLoadingItemsMonth(true)
            const parameters = {
                dtStart: dtStart,
                dtFinish: dtFinish
            }
            const response = await ExecuteAxios.api('delete', `/cost-day/between-selected-months/`, { params: parameters });

            if (response) {
                resetVariables();
                onUpdateShowDeleteMonthPanel(false)
                onUpdatePanelCostSpreadsheet(true)
            }
            return response
        } finally {
            onUpdateLoadingItemsMonth(false)
        }
    }

    return (
        <MiddlePanel isVisible={showDeleteMonthPanel}>
            <Panel style={{
                width: '400px',
                height: '100%',
                padding: '5px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5;',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <Panel titlePage={'Excluir meses'}
                    style={panelListStyle}
                    canViewCRUD={true}
                    postFunction={postFunction}
                    insertNameButton='Excluir'
                    cancelFunction={cancelFunction}
                    enableNewRecord={true}
                    canNewRecord={true}
                    enableDelete={true}
                    canDelete={true}
                    recordsSelected={[]}
                    inserting={true}>
                    <Panel style={styleButtonsMonth}>
                        <div id='attribute-control' style={{ flexDirection: 'center', width: '100%' }}>
                            <span className='span-role-control'>Mês inicial</span>
                            <ReactDataPickerComp
                                selected={dtStart}
                                onChange={(date) => { onUpdateDtStart(date) }}
                                showMonthYearPicker={true}
                                className='spreadsheet-new-month-date-picker cursor-pointer'
                                dateFormat={'MM/yyyy'}
                                setter={onUpdateDtStart}
                            />
                        </div>
                        <div id='attribute-control' style={{ flexDirection: 'center', width: '100%' }}>
                            <span className='span-role-control'>Mês final</span>
                            <ReactDataPickerComp
                                selected={dtFinish}
                                onChange={(date) => { setDtFinish(date) }}
                                showMonthYearPicker={true}
                                className='spreadsheet-new-month-date-picker cursor-pointer'
                                dateFormat={'MM/yyyy'}
                                setter={setDtFinish}
                            />
                        </div>
                    </Panel>
                </Panel>
            </Panel>
        </MiddlePanel >
    );
}

export default DeleteMonthPanel;
